$(function(){
  $('.open-menu').on('click', function(){
    $(this).css('visibility', 'hidden');
    $('#menu').removeClass('hide');
  });
  $('.close-menu').on('click', function(){
    $('.open-menu').css('visibility', 'visible');
    $('#menu').addClass('hide');
  });
  new SmoothScroll('a[href*="#"]', {updateURL: false});
  //goTop
  $(window).on('scroll',function(){
    var e=$(window).scrollTop();
    e>200?$("#goTop").addClass("showTop"):$("#goTop").removeClass("showTop");
  });
  $('#goTop').on('click',function(){
    $("body,html").animate({scrollTop:"0px"},200);
  });
  monitorExternalLink();  // monitor external link.
});

// Monitor external link
function monitorExternalLink(){
  var func_name = '[monitorExternalLink]';
  $('a').each(function(){
    var a = $(this);

    if (a.attr('href') != undefined) {
      var href = a.attr('href');
      if (href.indexOf('http://') != -1 || href.indexOf('https://') != -1 || href.match(/^\/fundpress_lp/) != null) {
        var dataVal = a.attr('data-val');
        if(!dataVal) dataVal = "";
        if (href.match(/^\/fundpress_lp/)){
          href = window.location.protocol + "//"+ window.location.host + href;
        }
        var url = '/top/statistical_external_link?data=' + dataVal + '&external_link=' + href;
        // console.log(func_name, 'url', url);
        a.on('click', function(){
          $.ajax({
            url: url,
            type: "get",
            async: false,
            cache: false,
            contentType: false,
            processData: false,
            success: function(data){
              // console.log(func_name, 'ajax success!');
              // console.log(data);
              return true;
            },
            error: function(){
              // console.log(func_name, 'ajax error!');
              return false;
            }
          });
        });
      }
    }
  });
}
